/*
 * sanitizeInput - Normalizes the input string to lowercase, removes spaces, and
 * optionally removes periods.
 */
export function sanitizeInput(
    input: string,
    removePeriods: boolean = false
): string {
    const s = input.trim().toLowerCase();
    return removePeriods ? s.replace(/[\s\.]+/g, '') : s.replace(/\s+/g, '');
}
